import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { CATMAN } from 'constants/constant';
import slaStyle from './SLA.style';
import moment from 'moment-timezone';
import { convertRefreshTime } from 'helper/helper';

const getLocalTzTime = (_d, _t) => {
	// user timezone
	const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const now = moment.utc();

	// get the zone offsets for this time, in minutes
	const cstOffset = moment.tz.zone('America/Chicago').utcOffset(now);
	const localTzOffset = moment.tz.zone(userTz).utcOffset(now);
	const diff = (cstOffset - localTzOffset) / 60;

	const localTime = moment().clone().set({ day: _d, hour: _t, minutes: 0 });
	localTime.add(diff, 'hour');
	localTime.tz(userTz);
	return localTime.format('dddd HH:mm');
};

const SLA = ({ selectedView, refreshTime }) => {
	// 1 => Monday, 8 => 8 AM
	const t = getLocalTzTime(1, 8);
	const classes = slaStyle();
	if (selectedView === null || !refreshTime) {
		return null;
	}

	const refTm = convertRefreshTime(moment(refreshTime));

	const refDay = refTm.day;
	const refDt = refTm.date;
	const refTime = refTm.time;
	const tz = refTm.timezone;

	const message = [CATMAN, 'BASIC_CATMAN'].includes(selectedView) ? (
		<span className={classes.text}>
			; `Items mapping for Category Manager refreshes every {t}.`
		</span>
	) : null;

	const sla = (
		<span className={classes.text}>
			{`Last refresh completed at: ${refDay}, ${refDt} at ${refTime} ${tz}`}
			{message}
		</span>
	);

	return <Typography>{sla}</Typography>;
};

SLA.propTypes = {
	selectedView: PropTypes.string,
	refreshTime: PropTypes.any
};

export default SLA;
